import { useMemo } from 'react';
import { notEmpty } from './useNodes';

export function useList<T>(listItems: readonly (T | null | undefined)[] | null | undefined) {
  return useMemo(() => listItems?.filter(notEmpty) ?? [], [listItems]);
}

export type ExtractArrayType<O, K extends keyof O> = NonNullable<O[K]> extends readonly (infer I)[] ? I : never;
